import React, {FC} from 'react';
import {useTranslation} from 'react-i18next';

import {PageTitle} from 'components';

import AppsHero from './AppsHero';
import ListOfApps from './ListOfApps';
import CreateApps from './CreateApps';

/** 注：正文内容来自 getApps API，暂不做后端数据本地化（已知限制，见 CLAUDE.md i18n 章节） */
const AppsHome: FC = () => {
  const {t} = useTranslation('common');

  return (
    <>
      <PageTitle canonicalUrl="https://www.xiangjifanyi.com/home/pricing" title={t('pricing.pageTitle')} />

      <AppsHero />
      <ListOfApps />
      <CreateApps />
    </>
  );
};

export default AppsHome;
